import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AssignmentRequestStatus, LegDetailStatus, RegionNames, RoleName, TransportType } from 'src/app/@shared/constants/Constant';
import { AssignRejectDialogComponent } from 'src/app/MaterialDialogs/assign-reject-dialog/assign-reject-dialog.component';
import { IAcceptOrRejectLegAssignmentPayLoad, ILegDetailsViewModel } from 'src/app/model/Vendor.model';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { ILegDetailsConfig } from 'src/app/model/reusableConfigData.model';
import { ItineraryService } from 'src/app/service/itinerary.service';
import { VendorDashboardService } from 'src/app/service/vendor-dashboard.service';
import { ServiceRequestStatusEnum } from '@enums/service-request-status.enum';

@Injectable({
    providedIn: 'root'
})

export class LegDetailService {

    private _subscriptions: Subscription = new Subscription();
    user: ILoggedInUserViewModel;
    dialogRef: MatDialogRef<AssignRejectDialogComponent>;
    acceptOrRejectLegAssignmentPayLoad: IAcceptOrRejectLegAssignmentPayLoad;
    selectedAssignmentRequestList: ILegDetailsViewModel[] = [];

    constructor(
        private _vendorDashboardService: VendorDashboardService, private _toaster: ToastrService,
        private _itineraryService: ItineraryService, private _dialog: MatDialog
    ) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this._subscriptions.add(this._vendorDashboardService.$resetSelectedLegDetailListFromLegDetailsService.subscribe(() => {
            this.selectedAssignmentRequestList = [];
        }));
    }

    returnStatusClassConfig(status: string) {
      switch (true) {
        case (status.toLowerCase() === LegDetailStatus.notStarted.toLowerCase()):
          return 'not_started-class';
        case (status === LegDetailStatus.enroute) || (status === LegDetailStatus.onBoard):
          return 'enroute-class';
        case (status === LegDetailStatus.onStandby):
          return 'on-standby-status-class';
        case (status === LegDetailStatus.repositioning):
          return 'reposition-status-class';
        case (status === LegDetailStatus.onScene || status === LegDetailStatus.inPosition):
          return 'on-scene-status-class';
        case (status === LegDetailStatus.wheelsUp):
          return 'wheels-up-air-status-class';
        case (status === LegDetailStatus.pickedUp):
          return 'picked-Up-class';
        case status.toLowerCase() === LegDetailStatus.droppedOff.toLowerCase() ||
        status.toLowerCase() === LegDetailStatus.landed.toLowerCase() ||
        status.toLowerCase() === ServiceRequestStatusEnum.COMPLETED.toLowerCase():
          return 'landedCompleted-class';
        case (status === LegDetailStatus.driverDone):
          return 'driverDone-class';
        case (status === LegDetailStatus.jobDone):
          return 'jobDone-class';
        default:
          return 'default-status-class';
      }
    }

    returnStatusDisabledConfig(transportType: string, currentStatus: string, statusOptionName: string, isNotInBoundOrOutBoundLeg?: boolean): boolean {
      if (transportType === TransportType.GROUND) {
        return (currentStatus === LegDetailStatus.notStarted && (statusOptionName === LegDetailStatus.driverDone || statusOptionName === LegDetailStatus.jobDone || statusOptionName === LegDetailStatus.droppedOff))
          || (currentStatus === LegDetailStatus.onScene && (statusOptionName === LegDetailStatus.driverDone || statusOptionName === LegDetailStatus.jobDone || statusOptionName === LegDetailStatus.droppedOff))
          || (currentStatus === LegDetailStatus.enroute && (statusOptionName === LegDetailStatus.driverDone || statusOptionName === LegDetailStatus.jobDone || statusOptionName === LegDetailStatus.droppedOff))
          || (currentStatus === LegDetailStatus.pickedUp && (statusOptionName === LegDetailStatus.driverDone || statusOptionName === LegDetailStatus.jobDone))
          || (this.user.role !== RoleName.ExecutiveAdmin && this.user.role !== RoleName.Coordinator && this.user.role !== RoleName.Management && (statusOptionName === LegDetailStatus.jobDone));
      }

      if (transportType === TransportType.AIR) {
        return (currentStatus === LegDetailStatus.notStarted && (statusOptionName === LegDetailStatus.jobDone || statusOptionName === LegDetailStatus.droppedOff || statusOptionName === LegDetailStatus.landed))
          || ((statusOptionName === LegDetailStatus.repositioning || statusOptionName === LegDetailStatus.inPosition || statusOptionName === LegDetailStatus.onStandby) && isNotInBoundOrOutBoundLeg)
          || (currentStatus === LegDetailStatus.onBoard && (statusOptionName === LegDetailStatus.jobDone || statusOptionName === LegDetailStatus.droppedOff || statusOptionName === LegDetailStatus.landed))
          || (currentStatus === LegDetailStatus.wheelsUp && (statusOptionName === LegDetailStatus.jobDone || statusOptionName === LegDetailStatus.droppedOff))
          || (this.user.role !== RoleName.ExecutiveAdmin && this.user.role !== RoleName.Coordinator && this.user.role !== RoleName.Management && (statusOptionName === LegDetailStatus.jobDone));
      }

      return false;
    }

    returnRegionClassConfig(regionName: string) {
      switch (regionName) {
        case RegionNames.East:
          return 'region-east';
        case RegionNames.West:
          return 'region-west';
        case RegionNames.Central:
          return 'region-central';
        case RegionNames.LifeSource:
          return 'region-lifeSource';
        default:
          return 'region-default';
      }
    }

  returnStatusClass(status: string): string {
      switch (status) {
        case AssignmentRequestStatus.accepted:
          return 'badge px-4 py-2 driverdone-status-color';
        case AssignmentRequestStatus.requested:
          return 'badge px-4 py-2 enroute-status-colors';
        case AssignmentRequestStatus.rejected:
          return 'badge px-4 py-2 _mt_2 droppedoff-status-color';
        default:
          return 'badge px-4 py-2 default-status-color';
      }
    }

    returnDisableReassignment(status: string): boolean {
      switch (status) {
        case AssignmentRequestStatus.accepted:
          return true;
        case AssignmentRequestStatus.requested:
          return true;
        case AssignmentRequestStatus.rejected:
          return false;
        default:
          return false;
      }
    }

    acceptOrRejectLegAssignmentRequest(legDetails: ILegDetailsViewModel, legDetailsConfig: ILegDetailsConfig, isAccepted: boolean) {
        if (confirm(isAccepted == true ? "Do you want to accept this request?" : "Do you want to reject this request?")) {
            this.acceptOrRejectLegAssignmentPayLoad = {
                isAccepted: isAccepted,
                legIdList: [legDetails.legId],
                updatedBy: legDetailsConfig.loggedInUserId,
                vendorId: legDetailsConfig.payLoadData.vendorId,
                rejectionReason: ''
            }
            const legDetailList: ILegDetailsViewModel[] = [legDetails];
            if (isAccepted) {
                this._subscriptions.add(this._vendorDashboardService.acceptOrRejectLegAssignmentRequest(this.acceptOrRejectLegAssignmentPayLoad).subscribe(
                    () => {
                        this._toaster.success("Assignment request accepted successfully!", "Success",
                            { timeOut: 6000, positionClass: "toast-top-center" });
                        this._itineraryService.$refreshLegDetails.next(null);
                        this.openAssignOrRejectDialog(legDetailList, 'Assign Driver');
                    },
                    () => {
                        this._toaster.warning("Something went wrong while accepting the request!", "Warning",
                            { timeOut: 6000, positionClass: "toast-top-center" });
                    }
                ));
            }
            else {
                this.openAssignOrRejectDialog(legDetailList, 'Reject Request');
            }
        }
    }

    acceptOrRejectSelectedRequests(isAccepted: boolean, memberId: string, vendorId: string) {
        const loggedInUser: ILoggedInUserViewModel = JSON.parse(localStorage.getItem("user"));
        if (confirm(isAccepted == true ? "Do you want to accept the selected requests?" : "Do you want to reject the selected requests?")) {
            let legIdList = [];
            this.selectedAssignmentRequestList.forEach((request) => {
                legIdList.push(request.legId);
            });
            this.acceptOrRejectLegAssignmentPayLoad = {
                isAccepted: isAccepted,
                legIdList: legIdList,
                updatedBy: memberId,
                vendorId: vendorId,
                rejectionReason: ''
            }
            if (isAccepted) {
                this._subscriptions.add(this._vendorDashboardService.acceptOrRejectLegAssignmentRequest(this.acceptOrRejectLegAssignmentPayLoad).subscribe(() => {
                    this._toaster.success("Selected assignment requests accepted successfully!", "Success",
                        { timeOut: 6000, positionClass: "toast-top-center" });
                    this._itineraryService.$refreshLegDetails.next(null);
                    this.openAssignOrRejectDialog(this.selectedAssignmentRequestList, 'Assign Driver');
                    this.selectedAssignmentRequestList = [];
                }, () => {
                    this._toaster.warning("Something went wrong while accepting the request!", "Warning",
                        { timeOut: 6000, positionClass: "toast-top-center" });
                }));
            }
            else {
                this.openAssignOrRejectDialog(this.selectedAssignmentRequestList, 'Reject Request');
                this.selectedAssignmentRequestList = [];
            }
        }
    }

    openAssignOrRejectDialog(legDetailList: ILegDetailsViewModel[], header: string) {
        this.dialogRef = this._dialog.open(AssignRejectDialogComponent, {
            minWidth: '60%',
            maxWidth: '50vw',
            position: {
                top: '2rem'
            },
            data: {
                legDetailList: legDetailList,
                header: header
            }
        })
    }

    manageSelectedLegDetailList(legDetail: ILegDetailsViewModel): void {
      const index = this.selectedAssignmentRequestList.findIndex(x => x.legId === legDetail.legId);
      if (index === -1) {
        this.selectedAssignmentRequestList.push(legDetail);
      } else {
        this.selectedAssignmentRequestList.splice(index, 1);
      }
    }

  openMultipleAssignmentDialog(header: string) {
        this.openAssignOrRejectDialog(this.selectedAssignmentRequestList, header);
    }

    isCheckBoxDisable(status: string, transportType: string): boolean {
        return (this.selectedAssignmentRequestList.length > 0) ?
            !this.selectedAssignmentRequestList.every(x => x.assignmentRequestStatus == status && x.transportType == transportType) : false;
    }

    returnTransportTypeClassConfig(transportType: string): string {
        if (transportType === TransportType.AIR) {
            return 'transportTypeAir';
        }
        else {
            return 'transportTypeGround';
        }
    }

}
